// @ts-nocheck
import React, {FC, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  Col,
  Button,
  Label,
  Row,
} from 'reactstrap';
import {createLoadingSelector} from '../../../selectors/loading';
import {createErrorSelector} from '../../../selectors/error';
import {EDIT_DEALER} from '../../../store/dealer/actionTypes';
import {useNavigate} from 'react-router-dom';
import {editDealer} from '../../../store/dealer/actions';
import {SweetAlert} from '../../Common/SweetAlert';
import ListCountries from '../../Lists/ListCountries';
import {FormProvider, useForm} from 'react-hook-form';
import FormField from '../../Common/FormField';
import FormCheckboxGroup from '../../Common/FormCheckboxGroup';

interface DealerFormProps {
  dealer: FullDealer,
}

/* eslint-disable camelcase */
export const DealerForm: FC<DealerFormProps> = (
    {
      dealer: {
        id,
        name,
        street,
        street_no,
        zip_code,
        city,
        country,
        phone,
        email,
        flags,
      },
    }) => {
  const dispatch = useDispatch();

  const loadingSelector = useSelector(createLoadingSelector([EDIT_DEALER]));
  const errorSelector = useSelector(createErrorSelector([EDIT_DEALER]));

  const [errorMsg, setErrorMsg] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const navigate = useNavigate();

  const form = useForm({
    defaultValues: {
      id,
      name,
      street,
      street_no,
      zip_code,
      city,
      country,
      phone: phone || '',
      email: email || '',
      flags: flags || [],
    },
  });
  const {
    handleSubmit,
  } = form;

  useEffect(() => {
    if (submitted) {
      setSuccessMsg(!loadingSelector && errorSelector.length === 0);
      setErrorMsg(!loadingSelector && errorSelector.length > 0);
    }
  }, [loadingSelector, errorSelector, submitted]);

  function handleValidSubmit(values) {
    setSubmitted(true);
    if (id) {
      const editedDealer: EditAPIDealer = {
        id: id,
        name: values.name,
        street: values.street,
        street_no: values.street_no,
        zip_code: values.zip_code,
        city: values.city,
        country: values.country,
        phone: values.phone,
        email: values.email,
        flags: values.flags,
      };
      dispatch(editDealer(editedDealer));
    }
  }

  return (
    <FormProvider {...form}>
      <form
        className="form-horizontal"
        onSubmit={handleSubmit(handleValidSubmit)}
      >
        {errorMsg ?
          <SweetAlert
            title="Error!"
            danger
            showConfirm={true}
            showCancel={false}
            confirmBtnBsStyle="danger"
            onConfirm={() => {
              setErrorMsg(false);
            }}
          >
            {errorMsg}
          </SweetAlert> : ''
        }
        {successMsg ? <SweetAlert
          title="Good job!"
          success
          showConfirm={true}
          showCancel={false}
          confirmBtnBsStyle="yellow"
          onConfirm={() => {
            navigate('/dealers');
          }}
        >
          The dealer has been updated!
        </SweetAlert> : null}
        <Row>
          <Col md="6">
            <Label htmlFor="flags">Options</Label>
            <FormCheckboxGroup
              name="flags"
              options={[
                {label: 'Can see downloads Textile', value: 'TEXTILE'},
                {label: 'Can see downloads Non-Textile', value: 'NON_TEXTILE'},
              ]}
              validate={{required: {value: true}}}
              errorMessage="Please select at least one option."
            />
          </Col>
        </Row>
        <Row>
          <Col md="6">
            <FormField
              name="name"
              className="form-control"
              placeholder="Name *"
              label="Name"
              type="text"
              validate={{required: {value: true}}}
              errorMessage="Please provide a valid name."
            />
          </Col>
        </Row>
        <Row>
          <Col md="3">
            <FormField
              name="street"
              className="form-control"
              placeholder="Street *"
              label="Street"
              type="text"
              validate={{required: {value: true}}}
              errorMessage="Please provide a valid street."
            />
          </Col>
          <Col md="2">
            <FormField
              name="street_no"
              className="form-control"
              placeholder="Street No *"
              label="Street No"
              type="text"
              validate={{required: {value: true}}}
              errorMessage="Please provide a valid street no."
            />
          </Col>
          <Col md="2">
            <FormField
              name="zip_code"
              className="form-control"
              placeholder="Zip Code *"
              label="Zip Code"
              type="text"
              validate={{required: {value: true}}}
              errorMessage="Please provide a valid zip code."
            />
          </Col>
          <Col md="3">
            <FormField
              name="city"
              className="form-control"
              placeholder="City *"
              label="City"
              type="text"
              validate={{required: {value: true}}}
              errorMessage="Please provide a valid city."
            />
          </Col>
          <Col md="3">
            <ListCountries
              initialSelect={country}
              required={true}
            />
          </Col>
        </Row>
        <Row>
          <Col md="3">
            <FormField
              name="phone"
              className="form-control"
              placeholder="Phone *"
              label="Phone"
              type="text"
              validate={{required: {value: true}}}
              errorMessage="Please provide a valid phone number."
            />
          </Col>
        </Row>
        <Row>
          <Col md="4">
            <FormField
              name="email"
              className="form-control"
              placeholder="Email Address*"
              label="Email"
              type="text"
              validate={{required: {value: true}}}
              errorMessage="Please provide a valid email address."
            />
          </Col>
        </Row>

        <Button
          disabled={loadingSelector}
          type="submit"
          color="primary"
        >
          Save
        </Button>
      </form>
    </FormProvider>
  );
};
/* eslint-enable camelcase */
